
export default {
  props: {
    product: {
      type: Object,
      default: null
    },
    sku: {
      type: String,
      default: null
    }
  },
  vessel: {
    title: {
      all: {
        color: 'black',
        fontSize: '2xl',
        marginBottom: 'sm'
      },
      lg: {
        fontSize: '3xl',
        marginBottom: 'md'
      }
    },
    description: {
      textColor: 'grey-darker',
      lineHeight: 'lg',
      marginTop: 'sm'
    },
    availability: {
      fontSize: 'sm',
      color: 'grey-darkest'
    }
  }
}
